import { render } from "./StoryTable.vue?vue&type=template&id=d8db2d70"
import script from "./StoryTable.vue?vue&type=script&lang=ts"
export * from "./StoryTable.vue?vue&type=script&lang=ts"
script.render = render

export default script